import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import api from "API/Api"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"

const TAB = { RULES: 1, COMPANY: 2, VENDOR: 3, PRODUCER: 4, V_REDEEM: 5, P_REDEEM: 6 }
const TAB_LABELS = {
  1: "Deduction Rules", 2: "Company Funds", 3: "Vendor Funds",
  4: "Producer Funds", 5: "Vendor Redemptions", 6: "Producer Redemptions",
}
const API_MAP = {
  1: { list: "fund-deduction-rules", create: "create-fund-deduction-rule", show: "fund-deduction-rule/", update: "update-fund-deduction-rule/", delete: "delete-fund-deduction-rule/", bulkType: "rules" },
  2: { list: "company-fund-entries", create: "create-company-fund-entry", show: "company-fund-entry/", update: "update-company-fund-entry/", delete: "delete-company-fund-entry/", bulkType: "company" },
  3: { list: "vendor-fund-entries", create: "create-vendor-fund-entry", show: "vendor-fund-entry/", update: "update-vendor-fund-entry/", delete: "delete-vendor-fund-entry/", bulkType: "vendor" },
  4: { list: "producer-fund-entries", create: "create-producer-fund-entry", show: "producer-fund-entry/", update: "update-producer-fund-entry/", delete: "delete-producer-fund-entry/", bulkType: "producer" },
  5: { preview: "vendor-redemption-preview", save: "save-vendor-redemption" },
  6: { preview: "producer-redemption-preview", save: "save-producer-redemption" },
}

const ProcurementFunds = () => {
  const { canAdd, canEdit, canDelete, canExport, MODULE } = usePermissions()
  const MID = MODULE.VLCC_INCENTIVES || 10

  const [tab, setTab] = useState(TAB.RULES)
  const [data, setData] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [search, setSearch] = useState("")
  const [showFilter, setShowFilter] = useState(false)
  // Per-column filter states
  const [fFundType, setFFundType]   = useState("")
  const [fOperation, setFOperation] = useState("")
  const [fDateFrom, setFDateFrom]   = useState("")
  const [fDateTo, setFDateTo]       = useState("")
  const [fVendor, setFVendor]       = useState("")
  const [fProducer, setFProducer]   = useState("")
  const clearColFilters = () => { setFFundType(""); setFOperation(""); setFDateFrom(""); setFDateTo(""); setFVendor(""); setFProducer("") }
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [deleteId, setDeleteId] = useState("")
  const [addModal, setAddModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [editData, setEditData] = useState(null)
  const [saving, setSaving] = useState(false)
  const addFormRef = React.useRef(null)
  const editFormRef = React.useRef(null)

  // Master dropdowns
  const [companies, setCompanies] = useState([])
  const [allPlants, setAllPlants] = useState([])
  const [plants, setPlants] = useState([])
  const [allCCs, setAllCCs] = useState([])
  const [mCCs, setMCCs] = useState([])
  const [mRoutes, setMRoutes] = useState([])
  const [mVendors, setMVendors] = useState([])
  const [mCenters, setMCenters] = useState([])
  const [mProducers, setMProducers] = useState([])
  const [fundTypes, setFundTypes] = useState([])

  // Redemption modal
  const [redemptionModal, setRedemptionModal] = useState(false)
  const [previewData, setPreviewData] = useState(null)
  const [previewSummary, setPreviewSummary] = useState(null)
  const [previewLoading, setPreviewLoading] = useState(false)
  const [redeemSaving, setRedeemSaving] = useState(false)
  const [rFilter, setRFilter] = useState({ company: "", plant: "", chilling_center: "", route: "", vendor: "", collection_center: "", producer: "", fund_type: "", upto_date: "" })
  const [rPlants, setRPlants] = useState([])
  const [rCCs, setRCCs] = useState([])
  const [rRoutes, setRRoutes] = useState([])
  const [rVendors, setRVendors] = useState([])
  const [rCenters, setRCenters] = useState([])
  const [rProducers, setRProducers] = useState([])


  const R = "\u20B9"
  const fmt = v => { const n = parseFloat(String(v || "0").replace(/,/g, "")); return isNaN(n) ? R + "0" : R + n.toLocaleString("en-IN") }
  const arr = r => Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || []
  const showCompany = companies.length > 1

  // Initial data load
  useEffect(() => {
    api.get("companies").then(r => setCompanies(arr(r))).catch(() => {})
    api.get("plants").then(r => { const p = arr(r); setAllPlants(p); setPlants(p); setRPlants(p) }).catch(() => {})
    api.get("centers").then(r => { const c = arr(r); setAllCCs(c); setMCCs(c); setRCCs(c) }).catch(() => {})
    api.get("vendors").then(r => { setMVendors(arr(r)); setRVendors(arr(r)) }).catch(() => {})
    api.get("fundtypes").then(r => setFundTypes(arr(r))).catch(() => {})
  }, [])

  const fetchData = useCallback(async () => {
    setDataLoaded(false); setCheckedItems({}); setParentChecked(false)
    if (tab >= 5) { setDataLoaded(true); return }
    try {
      const r = await api.get(API_MAP[tab].list)
      setData(Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || [])
    } catch (e) { console.error(e) }
    setDataLoaded(true)
  }, [tab])

  useEffect(() => { fetchData() }, [fetchData])

  // ── Cascade: add/edit modal ───────────────────────────────────────────────
  const mCompanyChange = async v => {
    setMCCs(allCCs); setMRoutes([]); setMVendors([]); setMCenters([]); setMProducers([])
    if (v) { try { setPlants(arr(await api.get("plants-by-company/" + v))) } catch (e) {} }
    else setPlants(allPlants)
    api.get("vendors").then(r => setMVendors(arr(r))).catch(() => {})
  }
  const mPlantChange = async v => {
    setMRoutes([]); setMCenters([]); setMProducers([])
    if (v) { try { setMCCs(arr(await api.get("chillings-by-plant/" + v))) } catch (e) {} }
    else setMCCs(allCCs)
  }
  const mCcChange = async v => {
    setMRoutes([]); setMCenters([]); setMProducers([])
    if (v) { try { setMRoutes(arr(await api.get("route-cc/" + v))) } catch (e) {} }
  }
  const mRouteChange = async v => {
    setMCenters([]); setMProducers([])
    if (v) { try { setMCenters(arr(await api.get("collection-center-route/" + v))) } catch (e) {} }
  }
  const mCenterChange = async v => {
    setMProducers([])
    if (v) { try { setMProducers(arr(await api.get("producer-center/" + v))) } catch (e) {} }
  }

  // ── Cascade: redemption modal filter ─────────────────────────────────────
  const rCompanyChange = async v => {
    setRFilter(f => ({ ...f, company: v, plant: "", chilling_center: "", route: "", vendor: "", collection_center: "", producer: "" }))
    setRCCs(allCCs); setRRoutes([]); setRVendors([]); setRCenters([]); setRProducers([])
    if (v) { try { setRPlants(arr(await api.get("plants-by-company/" + v))) } catch (e) {} }
    else { setRPlants(allPlants); }
    api.get("vendors").then(r => setRVendors(arr(r))).catch(() => {})
  }
  const rPlantChange = async v => {
    setRFilter(f => ({ ...f, plant: v, chilling_center: "", route: "", vendor: "", collection_center: "", producer: "" }))
    setRRoutes([]); setRCenters([]); setRProducers([])
    if (v) { try { setRCCs(arr(await api.get("chillings-by-plant/" + v))) } catch (e) {} }
    else setRCCs(allCCs)
  }
  const rCcChange = async v => {
    setRFilter(f => ({ ...f, chilling_center: v, route: "", vendor: "", collection_center: "", producer: "" }))
    setRRoutes([]); setRCenters([]); setRProducers([])
    if (v) { try { setRRoutes(arr(await api.get("route-cc/" + v))) } catch (e) {} }
  }
  const rRouteChange = async v => {
    setRFilter(f => ({ ...f, route: v, vendor: "", collection_center: "", producer: "" }))
    setRCenters([]); setRProducers([])
    if (v) { try { setRCenters(arr(await api.get("collection-center-route/" + v))) } catch (e) {} }
  }
  const rCenterChange = async v => {
    setRFilter(f => ({ ...f, collection_center: v, producer: "" }))
    setRProducers([])
    if (v) { try { setRProducers(arr(await api.get("producer-center/" + v))) } catch (e) {} }
  }

  // ── CRUD handlers ─────────────────────────────────────────────────────────
  const handleAdd = async (e, v) => {
    setSaving(true)
    try {
      const r = await api.post(API_MAP[tab].create, v)
      if (r.data.success) { fetchData(); setAddModal(false) }
      else { alert(r.data.message || r.data.errors ? JSON.stringify(r.data.errors) : "Failed to save.") }
    } catch (e) { alert("Error: " + (e.response?.data?.message || e.message)) }
    setSaving(false)
  }

  const openEdit = async id => {
    try {
      const r = await api.get(API_MAP[tab].show + id)
      setEditData(r.data.data)
      setMRoutes([]); setMCenters([]); setMProducers([])
      const d = r.data.data
      if (d?.plant) { try { setMCCs(arr(await api.get("chillings-by-plant/" + d.plant))) } catch (e) {} }
      if (d?.chilling_center) { try { setMRoutes(arr(await api.get("route-cc/" + d.chilling_center))) } catch (e) {} }
      if (d?.route) { try { setMCenters(arr(await api.get("collection-center-route/" + d.route))) } catch (e) {} }
      if (d?.collection_center) { try { setMProducers(arr(await api.get("producer-center/" + d.collection_center))) } catch (e) {} }
      setEditModal(true)
    } catch (e) { alert("Could not load record.") }
  }

  const handleEdit = async (e, v) => {
    setSaving(true)
    try {
      await api.put(API_MAP[tab].update + editData.id, v)
      fetchData(); setEditModal(false)
    } catch (e) { alert("Error: " + (e.response?.data?.message || e.message)) }
    setSaving(false)
  }

  const handleDelete = async () => {
    try { await api.delete(API_MAP[tab].delete + deleteId); fetchData() }
    catch (e) { alert("Delete failed: " + (e.response?.data?.data || e.message)) }
  }

  const handleMultiDelete = async () => {
    const ids = Object.keys(checkedItems).filter(k => checkedItems[k])
    if (!ids.length) return
    try { await api.post("delete-multiple-fund-entries", { type: API_MAP[tab].bulkType, items: ids }); setCheckedItems({}); setParentChecked(false); fetchData() }
    catch (e) { alert("Bulk delete failed.") }
  }

  const handleCheckbox = id => {
    setCheckedItems(prev => { const n = { ...prev, [id]: !prev[id] }; setParentChecked(data.length > 0 && data.every(r => n[r.id])); return n })
  }
  const handleParentCheckbox = () => {
    const n = !parentChecked; setParentChecked(n); const items = {}; data.forEach(r => { items[r.id] = n }); setCheckedItems(items)
  }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length

  // ── Redemption modal handlers ─────────────────────────────────────────────
  const openRedemptionModal = () => {
    setRFilter({ company: "", plant: "", chilling_center: "", route: "", vendor: "", collection_center: "", producer: "", fund_type: "", upto_date: "" })
    setPreviewData(null); setPreviewSummary(null)
    setRPlants(allPlants); setRCCs(allCCs); setRRoutes([]); setRVendors([]); setRCenters([]); setRProducers([])
    api.get("vendors").then(r => setRVendors(arr(r))).catch(() => {})
    setRedemptionModal(true)
  }

  const handlePreview = async () => {
    if (!rFilter.fund_type) return alert("Fund Type is required.")
    if (!rFilter.upto_date) return alert("Redemption Calculated Upto Date is required.")
    setPreviewLoading(true); setPreviewData(null); setPreviewSummary(null)
    try {
      const r = await api.post(API_MAP[tab].preview, rFilter)
      if (r.data.success) { setPreviewData(r.data.data || []); setPreviewSummary(r.data.summary) }
      else { alert("Preview failed: " + (r.data.data || "Unknown error")) }
    } catch (e) { alert("Preview error: " + (e.response?.data?.data || e.message)) }
    setPreviewLoading(false)
  }

  const handleSaveRedemption = async () => {
    if (!previewData || previewData.length === 0) return alert("No data to save. Run Preview first.")
    const balance = previewSummary?.balance || 0
    if (balance <= 0) return alert("Balance is zero or negative. Nothing to redeem.")
    setRedeemSaving(true)
    try {
      const payload = { ...rFilter, amount: balance }
      const r = await api.post(API_MAP[tab].save, payload)
      if (r.data.success) {
        setsuccess_dlg(true); setdynamic_title("Redemption Saved"); setdynamic_description(r.data.message || "Redemption saved successfully.")
        setRedemptionModal(false); fetchData()
      } else { alert("Save failed: " + (r.data.data || JSON.stringify(r.data.errors))) }
    } catch (e) { alert("Save error: " + (e.response?.data?.data || e.message)) }
    setRedeemSaving(false)
  }

  // ── Search + summary ──────────────────────────────────────────────────────
  const filtered = useMemo(() => {
    let d = data
    if (fFundType)  d = d.filter(r => (r.fund_type_name||"").toLowerCase().includes(fFundType.toLowerCase()))
    if (fOperation) d = d.filter(r => r.operation === fOperation)
    if (fDateFrom)  d = d.filter(r => r.entry_date >= fDateFrom)
    if (fDateTo)    d = d.filter(r => r.entry_date <= fDateTo)
    if (fVendor)    d = d.filter(r => (r.vendorName||"").toLowerCase().includes(fVendor.toLowerCase()))
    if (fProducer)  d = d.filter(r => (r.producerName||"").toLowerCase().includes(fProducer.toLowerCase()))
    if (!search) return d
    const s = search.toLowerCase()
    return d.filter(r => Object.values(r).some(v => String(v || "").toLowerCase().includes(s)))
  }, [data, search, fFundType, fOperation, fDateFrom, fDateTo, fVendor, fProducer])

  const summaryCards = useMemo(() => {
    if (tab === TAB.RULES) return [
      { label: "Total Rules", value: filtered.length, icon: "fa-list", color: "#6366f1" },
      { label: "Active", value: filtered.filter(r => r.status === "active").length, icon: "fa-check-circle", color: "#22c55e" },
      { label: "Inactive", value: filtered.filter(r => r.status !== "active").length, icon: "fa-times-circle", color: "#ef4444" },
    ]
    const add = filtered.filter(r => r.operation === "add").reduce((s, r) => s + parseFloat(r.amount || 0), 0)
    const ded = filtered.filter(r => r.operation === "deduct").reduce((s, r) => s + parseFloat(r.amount || 0), 0)
    return [
      { label: "Total Entries", value: filtered.length, icon: "fa-list", color: "#6366f1" },
      { label: "Total Added", value: fmt(add), icon: "fa-plus-circle", color: "#22c55e" },
      { label: "Total Deducted", value: fmt(ded), icon: "fa-minus-circle", color: "#ef4444" },
      { label: "Balance", value: fmt(add - ded), icon: "fa-balance-scale", color: "#f59e0b" },
    ]
  }, [tab, filtered])

  const exportCSV = () => {
    if (!filtered.length) return
    const keys = Object.keys(filtered[0])
    const csv = [keys, ...filtered.map(r => keys.map(k => `"${String(r[k] || "").replace(/"/g, '""')}"`))]
      .map(r => r.join(",")).join("\n")
    const b = new Blob([csv], { type: "text/csv" })
    const l = document.createElement("a"); l.href = URL.createObjectURL(b)
    l.download = `procurement_tab${tab}_${new Date().toISOString().slice(0, 10)}.csv`; l.click()
  }

  const switchTab = t => { setTab(t); setSearch(""); setShowFilter(false); clearColFilters(); setData([]); setPreviewData(null); setPreviewSummary(null) }

  // ── Icon button helper ────────────────────────────────────────────────────
  const ib = (bg, icon, title, onClick, dis) => (
    <button title={title} onClick={onClick} disabled={dis} style={{ width: "32px", height: "32px", borderRadius: "4px", background: bg, color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: dis ? "not-allowed" : "pointer", opacity: dis ? 0.5 : 1 }}>
      <i className={`fas ${icon}`}></i>
    </button>
  )


  // ── Table headers ─────────────────────────────────────────────────────────
  const colSpan = { 1: 11, 2: 9, 3: 13, 4: 14 }[tab] || 5

  const renderHeaders = () => {
    if (tab === TAB.RULES) return <tr><th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th><th>#</th><th>Fund Type</th><th>Rule Name</th><th>Apply On</th><th>Rate</th><th>Apply For</th><th>Apply Level</th><th>Credit To</th><th>Status</th><th>Action</th></tr>
    if (tab === TAB.COMPANY) return <tr><th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th><th>#</th><th>Company</th><th>Fund Type</th><th>Date</th><th>Operation</th><th>Amount</th><th>Remarks</th><th>Action</th></tr>
    if (tab === TAB.VENDOR) return <tr><th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th><th>#</th><th>Company</th><th>Plant</th><th>CC</th><th>Route</th><th>Vendor</th><th>Fund Type</th><th>Date</th><th>Operation</th><th>Amount</th><th>Remarks</th><th>Action</th></tr>
    if (tab === TAB.PRODUCER) return <tr><th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th><th>#</th><th>Company</th><th>Plant</th><th>CC</th><th>Route</th><th>Center</th><th>Producer</th><th>Fund Type</th><th>Date</th><th>Operation</th><th>Amount</th><th>Remarks</th><th>Action</th></tr>
    return null
  }

  const opBadge = op => (
    <span style={{ padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: 600, background: op === "add" ? "#dcfce7" : "#fde8e8", color: op === "add" ? "#166534" : "#991b1b" }}>
      {op === "add" ? "Add" : "Deduct"}
    </span>
  )
  const statusBadge = s => (
    <span style={{ padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: 600, background: s === "active" ? "#dcfce7" : "#fde8e8", color: s === "active" ? "#166534" : "#991b1b" }}>{s}</span>
  )

  const actionBtns = rec => (
    <div style={{ display: "flex", gap: "4px" }}>
      {canEdit(MID) && <button title="Edit" onClick={() => openEdit(rec.id)} style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#0d6efd", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer" }}><i className="fas fa-edit"></i></button>}
      {canDelete(MID) && <button title="Delete" onClick={() => { setDeleteId(rec.id); setconfirm_alert(true) }} style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#dc3545", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer" }}><i className="fas fa-trash"></i></button>}
    </div>
  )

  const renderRow = (rec, i) => {
    if (tab === TAB.RULES) return (
      <tr key={rec.id}>
        <td><input type="checkbox" checked={!!checkedItems[rec.id]} onChange={() => handleCheckbox(rec.id)} /></td>
        <td>{i + 1}</td>
        <td style={{ fontWeight: 600 }}>{rec.fund_type_name || "-"}</td>
        <td style={{ fontWeight: 600 }}>{rec.rule_name}</td>
        <td><span style={{ background: "#e0f2fe", color: "#0369a1", padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: 600 }}>{rec.rule_apply_on}</span></td>
        <td style={{ fontWeight: 600, color: "#0284c7" }}>{R}{parseFloat(rec.rate_per_qty || 0).toLocaleString("en-IN")}</td>
        <td><span style={{ background: "#f0fdf4", color: "#166534", padding: "2px 8px", borderRadius: "4px", fontSize: "11px" }}>{rec.rule_apply_for?.replace(/_/g, " ")}</span></td>
        <td><span style={{ background: "#faf5ff", color: "#7c3aed", padding: "2px 8px", borderRadius: "4px", fontSize: "11px" }}>{rec.rule_apply_level}</span></td>
        <td><span style={{ background: "#fff7ed", color: "#c2410c", padding: "2px 8px", borderRadius: "4px", fontSize: "11px" }}>{rec.credit_deduction_to?.replace(/_/g, " ")}</span></td>
        <td>{statusBadge(rec.status)}</td>
        <td>{actionBtns(rec)}</td>
      </tr>
    )
    if (tab === TAB.COMPANY) return (
      <tr key={rec.id}>
        <td><input type="checkbox" checked={!!checkedItems[rec.id]} onChange={() => handleCheckbox(rec.id)} /></td>
        <td>{i + 1}</td><td>{rec.companyName || "-"}</td>
        <td style={{ fontWeight: 600 }}>{rec.fund_type_name || "-"}</td>
        <td>{rec.entry_date}</td><td>{opBadge(rec.operation)}</td>
        <td style={{ fontWeight: 600, color: "#0284c7" }}>{fmt(rec.amount)}</td>
        <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{rec.remarks || "-"}</td>
        <td>{actionBtns(rec)}</td>
      </tr>
    )
    if (tab === TAB.VENDOR) return (
      <tr key={rec.id}>
        <td><input type="checkbox" checked={!!checkedItems[rec.id]} onChange={() => handleCheckbox(rec.id)} /></td>
        <td>{i + 1}</td><td>{rec.companyName || "-"}</td><td>{rec.plantName || "-"}</td>
        <td>{rec.ccName || "-"}</td><td>{rec.routeName || "-"}</td>
        <td style={{ fontWeight: 600 }}>{rec.vendorName || "-"}</td>
        <td>{rec.fund_type_name || "-"}</td><td>{rec.entry_date}</td>
        <td>{opBadge(rec.operation)}</td>
        <td style={{ fontWeight: 600, color: "#0284c7" }}>{fmt(rec.amount)}</td>
        <td style={{ maxWidth: "120px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{rec.remarks || "-"}</td>
        <td>{actionBtns(rec)}</td>
      </tr>
    )
    if (tab === TAB.PRODUCER) return (
      <tr key={rec.id}>
        <td><input type="checkbox" checked={!!checkedItems[rec.id]} onChange={() => handleCheckbox(rec.id)} /></td>
        <td>{i + 1}</td><td>{rec.companyName || "-"}</td><td>{rec.plantName || "-"}</td>
        <td>{rec.ccName || "-"}</td><td>{rec.routeName || "-"}</td>
        <td>{rec.centerName || "-"}</td>
        <td style={{ fontWeight: 600 }}>{rec.producerName || "-"}</td>
        <td>{rec.fund_type_name || "-"}</td><td>{rec.entry_date}</td>
        <td>{opBadge(rec.operation)}</td>
        <td style={{ fontWeight: 600, color: "#0284c7" }}>{fmt(rec.amount)}</td>
        <td style={{ maxWidth: "120px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{rec.remarks || "-"}</td>
        <td>{actionBtns(rec)}</td>
      </tr>
    )
    return null
  }

  // ── Form fields per tab ───────────────────────────────────────────────────
  const renderFormFields = d => {
    d = d || {}
    const fundSel = key => (
      <div className="mb-3">
        <AvField type="select" name="fund_type" label="Fund Type *" required value={d.fund_type || ""}>
          <option value="">Select</option>
          {fundTypes.map((f, i) => <option key={i} value={f.id}>{f.fund_type_name}</option>)}
        </AvField>
      </div>
    )
    const companySel = showCompany && (
      <Row><Col md={6}><div className="mb-3">
        <AvField type="select" name="company" label="Company" onChange={e => mCompanyChange(e.target.value)} value={d.company || ""}>
          <option value="">All Companies</option>
          {companies.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
        </AvField>
      </div></Col></Row>
    )
    const plantCCSel = (
      <Row>
        <Col md={6}><div className="mb-3">
          <AvField type="select" name="plant" label="Plant *" required onChange={e => mPlantChange(e.target.value)} value={d.plant || ""}>
            <option value="">Select</option>{plants.map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}
          </AvField>
        </div></Col>
        <Col md={6}><div className="mb-3">
          <AvField type="select" name="chilling_center" label="Chilling Center *" required onChange={e => mCcChange(e.target.value)} value={d.chilling_center || ""}>
            <option value="">Select</option>{mCCs.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
          </AvField>
        </div></Col>
      </Row>
    )
    const routeSel = (
      <Row><Col md={6}><div className="mb-3">
        <AvField type="select" name="route" label="Route *" required onChange={e => mRouteChange(e.target.value)} value={d.route || ""}>
          <option value="">Select</option>{mRoutes.map((r, i) => <option key={i} value={r.id}>{r.routeName}</option>)}
        </AvField>
      </div></Col></Row>
    )
    const opAmtRemarks = (
      <>
        <Row>
          <Col md={6}><div className="mb-3">
            <AvField type="select" name="operation" label="Operation *" required value={d.operation || "add"}>
              <option value="add">Add Funds</option>
              <option value="deduct">Deduct Funds</option>
            </AvField>
          </div></Col>
          <Col md={6}><div className="mb-3">
            <AvField name="amount" label="Amount *" type="number" min="0.01" step="0.01" required value={d.amount || ""} />
          </div></Col>
        </Row>
        <Row><Col md={12}><div className="mb-3">
          <AvField name="remarks" label="Remarks" type="textarea" rows="2" value={d.remarks || ""} />
        </div></Col></Row>
      </>
    )

    if (tab === TAB.RULES) return (
      <>
        <Row>
          <Col md={6}>{fundSel("r")}</Col>
          <Col md={6}><div className="mb-3"><AvField name="rule_name" label="Rule Name *" required value={d.rule_name || ""} /></div></Col>
        </Row>
        <Row>
          <Col md={6}><div className="mb-3"><AvField type="select" name="rule_apply_on" label="Rule Apply On *" required value={d.rule_apply_on || "quantity"}><option value="quantity">Quantity</option><option value="amount">Amount</option></AvField></div></Col>
          <Col md={6}><div className="mb-3"><AvField name="rate_per_qty" label="Rate Per Qty *" type="number" min="0" step="0.01" required value={d.rate_per_qty || ""} /></div></Col>
        </Row>
        <Row>
          <Col md={6}><div className="mb-3"><AvField type="select" name="rule_apply_for" label="Rule Apply For *" required value={d.rule_apply_for || "cc_purchases"}><option value="cc_purchases">CC Purchases</option><option value="vlcc_purchases">VLCC Purchases</option></AvField></div></Col>
          <Col md={6}><div className="mb-3"><AvField type="select" name="rule_apply_level" label="Rule Apply Level *" required value={d.rule_apply_level || "company"}><option value="company">Company</option><option value="plant">Plant</option><option value="cc">CC</option><option value="route">Route</option><option value="vendor">Vendor</option><option value="producer">Producer</option></AvField></div></Col>
        </Row>
        <Row>
          <Col md={6}><div className="mb-3"><AvField type="select" name="credit_deduction_to" label="Credit Deduction Amount To *" required value={d.credit_deduction_to || "funds_account"}><option value="funds_account">Funds Account</option><option value="self">Self</option></AvField></div></Col>
          {d.id && <Col md={6}><div className="mb-3"><AvField type="select" name="status" label="Status" value={d.status || "active"}><option value="active">Active</option><option value="inactive">Inactive</option></AvField></div></Col>}
        </Row>
      </>
    )
    if (tab === TAB.COMPANY) return (
      <>
        {companySel}
        <Row>
          <Col md={6}>{fundSel("c")}</Col>
          <Col md={6}><div className="mb-3"><AvField type="date" name="entry_date" label="Date *" required value={d.entry_date || ""} /></div></Col>
        </Row>
        {opAmtRemarks}
      </>
    )
    if (tab === TAB.VENDOR) return (
      <>
        {companySel}{plantCCSel}{routeSel}
        <Row>
          <Col md={6}><div className="mb-3"><AvField type="select" name="vendor" label="Vendor *" required value={d.vendor || ""}><option value="">Select</option>{mVendors.map((v, i) => <option key={i} value={v.id}>{v.vendorName}</option>)}</AvField></div></Col>
          <Col md={6}>{fundSel("v")}</Col>
        </Row>
        <Row><Col md={6}><div className="mb-3"><AvField type="date" name="entry_date" label="Date *" required value={d.entry_date || ""} /></div></Col></Row>
        {opAmtRemarks}
      </>
    )
    if (tab === TAB.PRODUCER) return (
      <>
        {companySel}{plantCCSel}{routeSel}
        <Row>
          <Col md={6}><div className="mb-3"><AvField type="select" name="collection_center" label="VLCC/Center *" required onChange={e => mCenterChange(e.target.value)} value={d.collection_center || ""}><option value="">Select</option>{mCenters.map((c, i) => <option key={i} value={c.id}>{c.centerName || c.collectionCenter}</option>)}</AvField></div></Col>
          <Col md={6}><div className="mb-3"><AvField type="select" name="producer" label="Producer *" required value={d.producer || ""}><option value="">Select</option>{mProducers.map((p, i) => <option key={i} value={p.id}>{p.producerName}</option>)}</AvField></div></Col>
        </Row>
        <Row>
          <Col md={6}>{fundSel("p")}</Col>
          <Col md={6}><div className="mb-3"><AvField type="date" name="entry_date" label="Date *" required value={d.entry_date || ""} /></div></Col>
        </Row>
        {opAmtRemarks}
      </>
    )
    return null
  }


  return (<>
    {/* Tab bar */}
    <div className="incentivePanel">
      {Object.entries(TAB_LABELS).map(([k, label]) => (
        <span key={k} onClick={() => switchTab(Number(k))} className={tab === Number(k) ? "acActive" : ""} style={{ cursor: "pointer" }}>{label}</span>
      ))}
    </div>

    {/* ── Redemption tabs (5 & 6) ── */}
    {(tab === TAB.V_REDEEM || tab === TAB.P_REDEEM) && (
      <div className="dashBody" style={{ marginTop: "10px" }}>
        <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <h4 style={{ margin: 0 }}>{TAB_LABELS[tab]}</h4>
            {canAdd(MID) && ib("#28a745", "fa-plus", "New Redemption", openRedemptionModal, false)}
          </div>
        </div>
        <div className="text-center py-5 text-muted">
          <i className="fas fa-coins fa-3x mb-3 d-block" style={{ color: "#6366f1" }}></i>
          <h5>Click <strong>+</strong> to generate a Redemption Preview</h5>
          <p style={{ fontSize: "13px" }}>Select filters, preview fund entries and save the redemption.</p>
        </div>
      </div>
    )}

    {/* ── CRUD tabs 1-4 ── */}
    {tab <= 4 && (
      <div className="dashBody" style={{ marginTop: "10px" }}>
        <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <h4 style={{ margin: 0 }}>{TAB_LABELS[tab]}</h4>
            {canAdd(MID) && ib("#28a745", "fa-plus", "Add New", () => { setMRoutes([]); setMCenters([]); setMProducers([]); setAddModal(true) }, false)}
            {canDelete(MID) && ib("#dc3545", "fa-trash", selectedCount > 0 ? `Delete ${selectedCount}` : "Delete Selected", () => { if (selectedCount > 0) setconfirm_multiple_alert(true); else alert("Select items first") }, false)}
            <button title="Toggle Filter" onClick={() => { setShowFilter(f => { if (f) clearColFilters(); return !f }) }}
              style={{ width: "32px", height: "32px", borderRadius: "4px", background: showFilter ? "#0d6efd" : "#6c757d", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer" }}>
              <i className="fas fa-filter"></i>
            </button>
            {canExport(MID) && ib("#17a2b8", "fa-download", "Export CSV", exportCSV, !filtered.length)}
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input type="text" className="form-control form-control-sm" placeholder="Search..." style={{ width: "180px", borderRadius: "4px 0 0 4px" }} value={search} onChange={e => setSearch(e.target.value)} />
            <button className="btn btn-primary btn-sm" style={{ borderRadius: "0 4px 4px 0", height: "31px" }}><i className="fas fa-search"></i></button>
          </div>
        </div>

        <Row className="mb-3 mt-2">
          {summaryCards.map((c, i) => (
            <Col md={3} sm={6} key={i}>
              <div style={{ background: "#fff", borderRadius: "10px", padding: "14px 16px", borderLeft: `4px solid ${c.color}`, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "8px", background: c.color + "15", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className={`fas ${c.icon}`} style={{ color: c.color, fontSize: "16px" }}></i>
                </div>
                <div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>{c.value}</div>
                  <div style={{ fontSize: "11px", color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.5px" }}>{c.label}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl">
            <thead>{renderHeaders()}</thead>
            <tbody>
              {showFilter && (() => {
                const fs = { border: "1px solid #dee2e6", borderRadius: "4px", width: "100%", fontSize: "12px", padding: "2px 6px", height: "28px" }
                const ds = <select style={fs} value={fOperation} onChange={e => setFOperation(e.target.value)}><option value="">All</option><option value="add">Add</option><option value="deduct">Deduct</option></select>
                if (tab === TAB.RULES) return (
                  <tr style={{ background: "#f0f4ff" }}>
                    <td></td><td></td>
                    <td><input style={fs} placeholder="Fund Type..." value={fFundType} onChange={e => setFFundType(e.target.value)} /></td>
                    <td colSpan={5}></td>
                    <td></td>
                    <td></td>
                    <td><button className="btn btn-sm btn-outline-danger" onClick={clearColFilters}><i className="fa fa-times"></i></button></td>
                  </tr>
                )
                if (tab === TAB.COMPANY) return (
                  <tr style={{ background: "#f0f4ff" }}>
                    <td></td><td></td><td></td>
                    <td><input style={fs} placeholder="Fund Type..." value={fFundType} onChange={e => setFFundType(e.target.value)} /></td>
                    <td><input type="date" style={fs} value={fDateFrom} onChange={e => setFDateFrom(e.target.value)} title="Date From" /></td>
                    <td>{ds}</td>
                    <td></td><td></td>
                    <td><button className="btn btn-sm btn-outline-danger" onClick={clearColFilters}><i className="fa fa-times"></i></button></td>
                  </tr>
                )
                if (tab === TAB.VENDOR) return (
                  <tr style={{ background: "#f0f4ff" }}>
                    <td></td><td></td><td></td><td></td><td></td><td></td>
                    <td><input style={fs} placeholder="Vendor..." value={fVendor} onChange={e => setFVendor(e.target.value)} /></td>
                    <td><input style={fs} placeholder="Fund Type..." value={fFundType} onChange={e => setFFundType(e.target.value)} /></td>
                    <td><input type="date" style={fs} value={fDateFrom} onChange={e => setFDateFrom(e.target.value)} title="Date From" /></td>
                    <td>{ds}</td>
                    <td></td><td></td>
                    <td><button className="btn btn-sm btn-outline-danger" onClick={clearColFilters}><i className="fa fa-times"></i></button></td>
                  </tr>
                )
                if (tab === TAB.PRODUCER) return (
                  <tr style={{ background: "#f0f4ff" }}>
                    <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                    <td><input style={fs} placeholder="Producer..." value={fProducer} onChange={e => setFProducer(e.target.value)} /></td>
                    <td><input style={fs} placeholder="Fund Type..." value={fFundType} onChange={e => setFFundType(e.target.value)} /></td>
                    <td><input type="date" style={fs} value={fDateFrom} onChange={e => setFDateFrom(e.target.value)} title="Date From" /></td>
                    <td>{ds}</td>
                    <td></td>
                    <td><button className="btn btn-sm btn-outline-danger" onClick={clearColFilters}><i className="fa fa-times"></i></button></td>
                    <td></td>
                  </tr>
                )
                return null
              })()}
              {!dataLoaded
                ? <tr><td colSpan={colSpan}><img className="loaderImg" src={loader} alt="Loading" /></td></tr>
                : filtered.length > 0
                  ? filtered.map((rec, i) => renderRow(rec, i))
                  : <tr><td colSpan={colSpan} className="text-center py-4"><i className="fas fa-inbox fa-2x text-muted mb-2 d-block"></i>No records found</td></tr>
              }
            </tbody>
          </Table>
        </div>
      </div>
    )}

    {/* ── Add Modal ── */}
    <Modal isOpen={addModal} toggle={() => setAddModal(false)} size="lg">
      <ModalHeader toggle={() => setAddModal(false)}>{TAB_LABELS[tab]} <span style={{ color: "#dc3545", fontSize: "13px" }}>[* required]</span></ModalHeader>
      <ModalBody>
        <AvForm ref={addFormRef} onValidSubmit={handleAdd}>
          {renderFormFields(null)}
          <div className="text-end mt-2">
            <button type="submit" className="btn btn-success me-2" disabled={saving}>{saving ? <><Spinner size="sm" /> Saving...</> : "Save Changes"}</button>
            <button type="button" className="btn btn-danger" onClick={() => setAddModal(false)}>Close</button>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>

    {/* ── Edit Modal ── */}
    <Modal isOpen={editModal} toggle={() => setEditModal(false)} size="lg">
      <ModalHeader toggle={() => setEditModal(false)}>Edit {TAB_LABELS[tab]} <span style={{ color: "#dc3545", fontSize: "13px" }}>[* required]</span></ModalHeader>
      <ModalBody>
        {editData && (
          <AvForm ref={editFormRef} onValidSubmit={handleEdit} model={editData}>
            {renderFormFields(editData)}
            <div className="text-end mt-2">
              <button type="submit" className="btn btn-success me-2" disabled={saving}>{saving ? <><Spinner size="sm" /> Saving...</> : "Save Changes"}</button>
              <button type="button" className="btn btn-danger" onClick={() => setEditModal(false)}>Close</button>
            </div>
          </AvForm>
        )}
      </ModalBody>
    </Modal>

    {/* ── Redemption Modal (matches screenshots) ── */}
    <Modal isOpen={redemptionModal} toggle={() => setRedemptionModal(false)} size="xl">
      <ModalHeader toggle={() => setRedemptionModal(false)}>
        {TAB_LABELS[tab]} <span style={{ color: "#dc3545", fontSize: "13px" }}>[* required]</span>
      </ModalHeader>
      <ModalBody>
        {/* Row 1: Plant | Chilling Center | Route */}
        <Row>
          {showCompany && <Col md={4}><div className="mb-3"><label className="form-label fw-bold" style={{ fontSize: "13px" }}>Company</label>
            <select className="form-select form-select-sm" value={rFilter.company} onChange={e => rCompanyChange(e.target.value)}>
              <option value="">All</option>{companies.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
            </select></div></Col>}
          <Col md={4}><div className="mb-3"><label className="form-label fw-bold" style={{ fontSize: "13px" }}>Plant</label>
            <select className="form-select form-select-sm" value={rFilter.plant} onChange={e => rPlantChange(e.target.value)}>
              <option value="">All</option>{rPlants.map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}
            </select></div></Col>
          <Col md={4}><div className="mb-3"><label className="form-label fw-bold" style={{ fontSize: "13px" }}>Chilling Center</label>
            <select className="form-select form-select-sm" value={rFilter.chilling_center} onChange={e => rCcChange(e.target.value)}>
              <option value="">All</option>{rCCs.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
            </select></div></Col>
          <Col md={4}><div className="mb-3"><label className="form-label fw-bold" style={{ fontSize: "13px" }}>Route</label>
            <select className="form-select form-select-sm" value={rFilter.route} onChange={e => rRouteChange(e.target.value)}>
              <option value="">All</option>{rRoutes.map((r, i) => <option key={i} value={r.id}>{r.routeName}</option>)}
            </select></div></Col>
        </Row>
        {/* Row 2: Vendor/Center/Producer | Fund Type | Upto Date */}
        <Row>
          {tab === TAB.V_REDEEM
            ? <Col md={4}><div className="mb-3"><label className="form-label fw-bold" style={{ fontSize: "13px" }}>Vendor</label>
                <select className="form-select form-select-sm" value={rFilter.vendor} onChange={e => setRFilter(f => ({ ...f, vendor: e.target.value }))}>
                  <option value="">All</option>{rVendors.map((v, i) => <option key={i} value={v.id}>{v.vendorName}</option>)}
                </select></div></Col>
            : <>
                <Col md={4}><div className="mb-3"><label className="form-label fw-bold" style={{ fontSize: "13px" }}>Center</label>
                  <select className="form-select form-select-sm" value={rFilter.collection_center} onChange={e => rCenterChange(e.target.value)}>
                    <option value="">All</option>{rCenters.map((c, i) => <option key={i} value={c.id}>{c.centerName || c.collectionCenter}</option>)}
                  </select></div></Col>
                <Col md={4}><div className="mb-3"><label className="form-label fw-bold" style={{ fontSize: "13px" }}>Producer</label>
                  <select className="form-select form-select-sm" value={rFilter.producer} onChange={e => setRFilter(f => ({ ...f, producer: e.target.value }))}>
                    <option value="">All</option>{rProducers.map((p, i) => <option key={i} value={p.id}>{p.producerName}</option>)}
                  </select></div></Col>
              </>
          }
          <Col md={4}><div className="mb-3"><label className="form-label fw-bold" style={{ fontSize: "13px" }}>Fund Type <span style={{ color: "#dc3545" }}>*</span></label>
            <select className="form-select form-select-sm" value={rFilter.fund_type} onChange={e => setRFilter(f => ({ ...f, fund_type: e.target.value }))}>
              <option value="">Select</option>{fundTypes.map((f, i) => <option key={i} value={f.id}>{f.fund_type_name}</option>)}
            </select></div></Col>
          <Col md={4}><div className="mb-3"><label className="form-label fw-bold" style={{ fontSize: "13px" }}>Redemption Calculated Upto Date <span style={{ color: "#dc3545" }}>*</span></label>
            <input type="date" className="form-control form-control-sm" value={rFilter.upto_date} onChange={e => setRFilter(f => ({ ...f, upto_date: e.target.value }))} />
          </div></Col>
        </Row>
        <div className="mb-3">
          <button className="btn btn-primary btn-sm" onClick={handlePreview} disabled={previewLoading}>
            {previewLoading ? <><Spinner size="sm" /> Loading...</> : <><i className="fas fa-eye me-1"></i>Preview</>}
          </button>
        </div>

        {/* Summary cards */}
        {previewSummary && (
          <Row className="mb-3">
            {[{ label: "Total Entries", value: previewSummary.count, color: "#6366f1", icon: "fa-list" },
              { label: "Total Added", value: fmt(previewSummary.totalAdd), color: "#22c55e", icon: "fa-plus-circle" },
              { label: "Total Deducted", value: fmt(previewSummary.totalDeduct), color: "#ef4444", icon: "fa-minus-circle" },
              { label: "Balance", value: fmt(previewSummary.balance), color: "#f59e0b", icon: "fa-balance-scale" }
            ].map((c, i) => (
              <Col md={3} key={i}>
                <div style={{ background: "#fff", borderRadius: "8px", padding: "12px 14px", borderLeft: `4px solid ${c.color}`, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                  <div style={{ width: "36px", height: "36px", borderRadius: "8px", background: c.color + "18", display: "flex", alignItems: "center", justifyContent: "center" }}><i className={`fas ${c.icon}`} style={{ color: c.color, fontSize: "15px" }}></i></div>
                  <div><div style={{ fontSize: "17px", fontWeight: 700, color: "#1e293b" }}>{c.value}</div><div style={{ fontSize: "10px", color: "#6c757d", textTransform: "uppercase" }}>{c.label}</div></div>
                </div>
              </Col>
            ))}
          </Row>
        )}

        {/* Preview table */}
        {previewData !== null && (
          previewData.length === 0
            ? <div className="text-center py-3 text-muted"><i className="fas fa-inbox fa-2x mb-2 d-block"></i>No fund entries found for the selected filters.</div>
            : <div className="table-responsive" style={{ maxHeight: "300px", overflowY: "auto" }}>
                <Table className="table mb-0 dairyTbl" size="sm">
                  <thead><tr><th>#</th><th>Plant</th><th>CC</th><th>Route</th>
                    {tab === TAB.V_REDEEM ? <th>Vendor</th> : <><th>Center</th><th>Producer</th></>}
                    <th>Fund Type</th><th>Date</th><th>Operation</th><th>Amount</th><th>Remarks</th>
                  </tr></thead>
                  <tbody>
                    {previewData.map((r, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td><td>{r.plantName || "-"}</td><td>{r.ccName || "-"}</td><td>{r.routeName || "-"}</td>
                        {tab === TAB.V_REDEEM
                          ? <td style={{ fontWeight: 600 }}>{r.vendorName || "-"}</td>
                          : <><td>{r.centerName || "-"}</td><td style={{ fontWeight: 600 }}>{r.producerName || "-"}</td></>
                        }
                        <td>{r.fund_type_name || "-"}</td><td>{r.entry_date}</td>
                        <td><span style={{ padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: 600, background: r.operation === "add" ? "#dcfce7" : "#fde8e8", color: r.operation === "add" ? "#166534" : "#991b1b" }}>{r.operation === "add" ? "Add" : "Deduct"}</span></td>
                        <td style={{ fontWeight: 600, color: "#0284c7" }}>{fmt(r.amount)}</td>
                        <td style={{ maxWidth: "120px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.remarks || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
        )}
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-success" onClick={handleSaveRedemption} disabled={redeemSaving || !previewData?.length || (previewSummary?.balance || 0) <= 0}>
          {redeemSaving ? <><Spinner size="sm" /> Saving...</> : "Save Changes"}
        </button>
        <button className="btn btn-danger" onClick={() => setRedemptionModal(false)}>Close</button>
      </ModalFooter>
    </Modal>

    {/* SweetAlerts */}
    {confirm_alert && <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger" onConfirm={() => { handleDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Record deleted.") }} onCancel={() => setconfirm_alert(false)}>You won&apos;t be able to revert this!</SweetAlert>}
    {confirm_multiple_alert && <SweetAlert title={`Delete ${selectedCount} items?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger" onConfirm={() => { handleMultiDelete(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description(`${selectedCount} record(s) deleted.`) }} onCancel={() => setconfirm_multiple_alert(false)}>You won&apos;t be able to revert this!</SweetAlert>}
    {success_dlg && <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>}
  </>)
}

export default ProcurementFunds
